export const selectMonth = () => {
  switch (new Date().getMonth()) {
    case 0:
      return "Enero";
    case 1:
      return "Febrero";
    case 2:
      return "Marzo";
    case 3:
      return "Abril";
    case 4:
      return "Mayo";
    case 5:
      return "Junio";
    case 6:
      return "Julio";
    case 7:
      return "Agosto";
    case 8:
      return "Setiembre";
    case 9:
      return "Octubre";
    case 10:
      return "Noviembre";
    case 11:
      return "Diciembre";
    default:
      return "Este mes";
  }
};

//Function to select year
export const selectYear = () => {
  return `${new Date().getFullYear()}`;
};

/**
 * Returns a string indicating the age of a date in ISOString format.
 * If the date is older than 8 days, it returns the formatted date as a string using new Date(date).toLocaleString().
 * If the date is less than 8 days but more than 24 hours old, it returns a string in the format "X hours ago".
 * If the date is less than 24 hours but more than 1 hour old, it returns a string in the format "X minutes ago".
 * If the date is less than 1 hour old, it returns a string in the format "X seconds ago".
 * If the date is more than 24 hours old, it returns a string in the format "X days ago".
 *
 * @param {string} iso - The date in ISOString format.
 * @returns {string} The string indicating the age of the date.
 */
export const selectDateString = (iso) => {
  try {
    // Get the current date
    const currentDate = new Date();

    // Subtract 8 days from the current date
    const limitDate = new Date();
    limitDate.setDate(currentDate.getDate() - 8);

    // Convert the ISOString to a date object
    const date = new Date(iso);

    // Check if the date is older than 8 days
    if (date < limitDate) {
      // Date is older than 8 days
      //return new Date(date).toLocaleDateString();
      return date.toLocaleDateString();
    } else {
      // Date is less than 8 days old
      const differenceSeconds = Math.floor((currentDate - date) / 1000);

      //Caso hace X segundos(hace menos de un minuto)
      if (differenceSeconds < 60) {
        return `Hace ${differenceSeconds} segundos`;
      }

      //Case hace x minutos(hace menos de una hora)
      if (differenceSeconds < 3600) {
        return `Hace ${Math.floor(differenceSeconds / 60)} minutos`;
      }

      //Caso hace x horas(hace menos de un día)
      if (differenceSeconds < 86400) {
        return `Hace ${Math.floor(differenceSeconds / 3600)} horas`;
      }

      //caso hace x días(hace menos de 8 días)
      return `Hace ${Math.floor(differenceSeconds / 86400)} días`;
    }
  } catch (e) {
    console.log(e);
    return new Date(iso).toLocaleDateString();
  }
};

export const getFechaAlLoTico = (string) => {
  let date = new Date(string);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;

  return day + "/" + month + "/" + year;
};
